class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("change", () => {
        this.dispatchEvent(
          new CustomEvent("baseline:variantpicker:change", {
            detail: { input },
            bubbles: true,
            composed: true,
          })
        );

        document
          .querySelectorAll('input[value="' + input.value + '"]')
          .forEach((el) => {
            el.checked = true;
          });
        document
          .querySelectorAll('product-form input[name="id"]')
          .forEach((el) => {
            el.value = input.dataset.variantId;
          });

        window.history.replaceState({}, "", `${input.dataset.variant}`);
      });
    });
  }
}
customElements.define('variant-picker', VariantPicker);

class ProductInfo extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.setListeners();
  }


  setListeners() {
    document.addEventListener('baseline:variantpicker:change', (event) => {
      this.render(event.detail.input.dataset.variant);
    });
    
  }

  async render(url) {
    const response = await fetch(url + '&view=info');
    const responseText = await response.text();

    const html = new DOMParser().parseFromString(responseText, 'text/html');

    this.sectionsToRender().forEach((selector) => {
      const newSection = html.querySelector(selector);
      const currentSection = this.querySelector(selector);

      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }
    });

    this.setListeners();
  }

  sectionsToRender() {
    return [
      '[data-buy-buttons]'
    ];
  }
}
customElements.define('product-info', ProductInfo);

class ProductForm extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('form').addEventListener('submit', (event) => {
      this.submit(event);
    });
  }

  async submit(event) {
    event.preventDefault();

    this.dispatchEvent(
      new CustomEvent('baseline:productform:loading', {
        bubbles: true,
      })
    );

    event.preventDefault();

    liveRegion(window.theme.strings.loading);

    const formData = new FormData(event.target);
    const formId = event.target.getAttribute('id');

    const options = fetchConfigDefaults('application/javascript');

    formData.append('sections', 'cart-items,cart-footer,cart-item-count');
    formData.append('sections_url', window.location.pathname);

    options.body = formData;
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete options.headers['Content-Type'];

    let response, data;

    response = await fetch(`${theme.routes.cart_add_url}`, options);
    data = await response.json();

    if (data.status) {
      let errors = data.errors || data.description;
      let message = data.description || data.message;

      const errorDetail = {
        sourceId: formId,
        variantId: Number(formData.get('id')),
        errors,
        message,
      };

      this.dispatchEvent(
        new CustomEvent('baseline:productform:error', {
          detail: errorDetail,
          bubbles: true,
        })
      );

      const form = this.querySelector('form');
      const productRootEl = form.closest('[data-product-root]') || null;

      document.dispatchEvent(
        new CustomEvent('theme:product:error:add-to-cart', {
          detail: {
            productRootEl,
            form,
            ...errorDetail,
          },
        })
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('baseline:productform:success', {
          bubbles: true,
        })
      );

      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: data,
            sourceId: formId,
          },
        })
      );
    }
  }

}
customElements.define('product-form', ProductForm);
class StickyQuickBuy extends HTMLElement {

  constructor() { 
    super();
    this.trackerTop = document.querySelector('[data-variant-picker]');
    this.trackerBottom = document.querySelector('[data-buy-buttons]');
  }

  connectedCallback() {
    this.setListeners();
  }

  setListeners() {
    this.querySelector('[data-select-variant]').addEventListener('click', () => {
      this.toggleVariantPicker();
    });

    this.querySelector('[data-soldout]').addEventListener('click', () => {
      this.toggleVariantPicker();
    });

    this.addEventListener('baseline:productform:success', () => {
      this.resetModal();
    });

    window.addEventListener('scroll', () => {
      this.handleVisibility();
    });
  }

  handleVisibility() {
    const isTopVisible = this.isElementVisible(this.trackerTop);
    const isBottomVisible = this.isElementVisible(this.trackerBottom);

    const trackerVisible = isTopVisible || isBottomVisible;

    this.toggleAttribute('active', !trackerVisible);

  }

  resetModal() {
    this.querySelector('[data-variants]').toggleAttribute('open', false);
    this.querySelector('input:checked').checked = false;
  }

  toggleVariantPicker() {
    this.querySelector('[data-variants]').toggleAttribute('open');
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  

}
customElements.define('sticky-quick-buy', StickyQuickBuy);